import api from "./api";

export function fnGetCustLogo() {
    const response = api.get("/user-images")
    return response
}